import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_319: DocMigration = {
  maxSchemaVersion: "0.0.319",
  description: "Remove paramFromEnd boolean in lieu of paramAnchor enum",
  apply(json: any): any {
    for (const id in json.props) {
      const prop = json.props[id];
      const { paramFromEnd, ...rest } = prop;
      json.props[id] = {
        ...rest,
        paramAnchor: getParamAnchor(paramFromEnd),
      };
    }

    for (const id in json.casework) {
      const casework = json.casework[id];
      const { paramFromEnd, ...rest } = casework;
      json.casework[id] = {
        ...rest,
        paramAnchor: getParamAnchor(paramFromEnd),
      };
    }

    for (const id in json.electricalDevices) {
      const elecDev = json.electricalDevices[id];
      if (elecDev["deviceType"] === "LOAD") {
        if (elecDev["position"].type !== "WALL") {
          continue;
        }

        const {
          position: { paramFromEnd, ...restPosition },
          ...restDev
        } = elecDev;
        json.electricalDevices[id] = {
          ...restDev,
          position: {
            ...restPosition,
            paramAnchor: getParamAnchor(paramFromEnd),
          },
        };

        continue;
      }

      if (elecDev["deviceType"] === "CONTROLLER") {
        if (elecDev["controllerType"] !== "SWITCH") {
          continue;
        }

        const { selections, ...restDev } = elecDev;
        json.electricalDevices[id] = {
          ...restDev,
          selections: selections.map((selection) => {
            if (!selection["explicitQueryPoint"]) {
              return selection;
            }

            const {
              explicitQueryPoint: {
                position: { paramFromEnd, ...restPosition },
                ...restExplicitQueryPoint
              },
              ...restSelection
            } = selection;
            return {
              ...restSelection,
              explicitQueryPoint: {
                ...restExplicitQueryPoint,
                position: {
                  ...restPosition,
                  paramAnchor: getParamAnchor(paramFromEnd),
                },
              },
            };
          }),
        };

        continue;
      }
    }

    for (const id in json.openings) {
      const opening = json.openings[id];
      if (opening["type"] !== "DOOR_V2" && opening["type"] !== "WINDOW_V2") {
        continue;
      }
      const { paramFromEnd, ...rest } = opening;
      json.openings[id] = {
        ...rest,
        paramAnchor: getParamAnchor(paramFromEnd),
      };
    }

    for (const id in json.edgeBehaviors) {
      const behavior = json.edgeBehaviors[id];
      if (behavior["edgeBehaviorType"] !== "ELEVATION_NOTE") {
        continue;
      }
      json.edgeBehaviors[id] = {
        ...behavior,
        paramAnchor: "START",
      };
    }

    return json;
  },
};

function getParamAnchor(paramFromEnd) {
  if (paramFromEnd === true) {
    return "END";
  } else {
    return "START";
  }
}

export default migration_0_0_319;
